<template>
  <div class="cd-section" id="blogs">
    <!--     *********     BLOGS 3      *********      -->
    <div class="blogs-3">
      <div class="container">
        <div class="row">
          <div class="col-md-12 ml-auto mr-auto">
            <br>
            <h2 class="title text-center">Noticias</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto">
            <br>
            <card type="blog" plain v-for="x in list" v-bind:key="x.uuid">
              <div class="row">
                <div class="col-md-4">
                  <div class="card-image">
                    <a :href="x.postEntryUrl">
                      <div
                        class="thumbnail img rounded img-raised"
                        :style="getImageAttribute(x.thumbImageUrl)"
                      ></div>
                      <!-- <img class="img rounded img-raised thumbnail" :src="x.thumbImageUrl"> -->
                    </a>
                  </div>
                </div>
                <div class="col-md-8">
                  <h3 class="card-title">
                    <a :href="x.postEntryUrl">{{x.title}}</a>
                  </h3>
                  <p class="card-description">
                    {{x.content}}
                    <a :href="x.postEntryUrl">Leer más</a>
                  </p>
                  <div class="author">
                    <!-- <img v-lazy="'img/olivia.jpg'" alt="..." class="avatar img-raised"> -->
                    <h6 class="category text-info">
                      <i class="now-ui-icons media-2_sound-wave"></i>
                      {{x.daysPassed}}
                    </h6>
                    <!-- <span>Editor de OSAPM</span> -->
                  </div>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card } from "@/components";
export default {
  components: { Card },
  data() {
    return {
      list: []
    };
  },
  async mounted() {
    await this.load();
  },
  methods: {
    load: async function() {
      try {
        let response = await this.$zaiq().get("Noticia/Page", {
          params: {
            page: 1
          }
        });

        this.list = response.data.result.items;
      } catch (e) {
        if (this.vErrors) this.vErrors.items.push(e);
        console.log(e);
      }
    },
    getImageAttribute: function(url) {
      return "background-image: url(" + url + ");";
    }
  }
};
</script>
<style>
</style>
